import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  addFreightTemplate,
  updateFreightTemplate,
  deleteFreightTemplate,
  pageFreightTemplates,
  getFreightTemplateDetail
} from '../../api/freightTemplate';
import { message } from 'antd';

// 分页查询运费模板列表的异步 thunk
export const fetchFreightTemplates = createAsyncThunk(
  'freightTemplate/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await pageFreightTemplates(params);
      return response.data;
    } catch (error) {
      message.error('获取运费模板列表失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 获取运费模板详情的异步 thunk
export const fetchFreightTemplateDetail = createAsyncThunk(
  'freightTemplate/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getFreightTemplateDetail(id);
      return response.data;
    } catch (error) {
      message.error('获取运费模板详情失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 添加运费模板的异步 thunk
export const createFreightTemplate = createAsyncThunk(
  'freightTemplate/create',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await addFreightTemplate(data);

      if (response.code === 200) {
        message.success('添加运费模板成功');
        // 重新获取列表
        dispatch(fetchFreightTemplates());
        return response.data;
      } else {
        message.error(response.message || '添加失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('添加运费模板请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 更新运费模板的异步 thunk
export const updateFreightTemplateAction = createAsyncThunk(
  'freightTemplate/update',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateFreightTemplate(data);

      if (response.code === 200) {
        message.success('更新运费模板成功');
        // 重新获取列表
        dispatch(fetchFreightTemplates());
        return response.data;
      } else {
        message.error(response.message || '更新失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('更新运费模板请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 删除运费模板的异步 thunk
export const deleteFreightTemplateAction = createAsyncThunk(
  'freightTemplate/delete',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteFreightTemplate(id);

      if (response.code === 200) {
        message.success('删除运费模板成功');
        // 重新获取列表
        dispatch(fetchFreightTemplates());
        return response.data;
      } else {
        message.error(response.message || '删除失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('删除运费模板请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

const freightTemplateSlice = createSlice({
  name: 'freightTemplate',
  initialState: {
    templates: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null,
    currentTemplate: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentTemplate: (state, action) => {
      state.currentTemplate = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // 获取列表
      .addCase(fetchFreightTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFreightTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload.records;
        state.total = action.payload.total;
        state.page = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchFreightTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 获取详情
      .addCase(fetchFreightTemplateDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFreightTemplateDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.currentTemplate = action.payload;
      })
      .addCase(fetchFreightTemplateDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 新增
      .addCase(createFreightTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createFreightTemplate.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createFreightTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 更新
      .addCase(updateFreightTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFreightTemplateAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateFreightTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 删除
      .addCase(deleteFreightTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFreightTemplateAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteFreightTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const {
  setPage,
  setPageSize,
  setCurrentTemplate
} = freightTemplateSlice.actions;

export default freightTemplateSlice.reducer;
